import {
  FileMoveDirectoryFragment,
  FileMoveFileFragment,
} from '../../../../../graphql/generated';

type StorageObjectFragment = FileMoveFileFragment | FileMoveDirectoryFragment;

export const takeDirectories = (objects?: StorageObjectFragment[]) => {
  if (objects) {
    return objects.filter(
      (storageObject) => storageObject.__typename === 'Directory'
    ) as FileMoveDirectoryFragment[];
  }

  return [];
};
